module.exports = "/assets/data/487683889b1094ba555af995fc6ea048-MK43.data.json";